$shm_button_copy $mol_pop_over
	copied? false
	hint \
	event *
		^
		focusout? <=> event_blur? null
	attr *
		^
		copied <= copied
	Anchor <= Button $mol_button_copy
		title <= title \
		hint \
		attr *
			^
			aria-label <= hint
		text <= text
		blobs <= blobs
		sub <= button_sub /
			<= Icon $mol_icon_content_copy
			<= title
		click? <=> click? null
	bubble_content /
		<= Status $mol_view
			attr *
				^
				copied <= copied
			sub /
				<= status_text \Скопировано
	blobs /$mol_blob
		<= text_blob? $mol_blob /
			/BlobPart <= text <= title
			* type \text/plain
		<= html_blob? $mol_blob /
			/BlobPart <= html \
			* type \text/html
	button_sub /
		<= Icon $mol_icon_content_copy
		<= title \
